<template>
  <div class="checkbox-container spacex-8">
    <div
      class="checkbox"
      :class="[`checkbox_${checked}`, { checkbox_disabled: disabled }]"
      @click.stop="handleChecking"
    >
      <Icon v-if="partially" :key="checked" type="minus" color="oncolor" size="16" />
      <Icon v-else-if="checked" type="check" color="oncolor" size="16" />
    </div>
    <div v-if="$slots.default" class="checkbox-text">
      <slot />
    </div>
  </div>
</template>

<script>
  import Icon from '@/components/ui/Icon';

  export default {
    name: 'Checkbox',
    components: {
      Icon,
    },
    model: {
      prop: 'checked',
      event: 'check',
    },
    props: {
      checked: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      partially: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      handleChecking() {
        if (!this.disabled) {
          this.$emit('check', !this.checked);
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import 'src/styles/colors';

  .checkbox-container {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
  }

  .checkbox-text {
    color: black;
    font-weight: 500;
    font-size: 14px;
  }

  .checkbox {
    transition: background-color 0.2s ease;
    cursor: pointer;
    background: white;

    border: 1px solid $grey200;
    box-sizing: border-box;
    border-radius: 4px;
    width: 20px;
    height: 20px;
    padding-left: 1px;
    padding-top: 1px;

    &_false:hover {
      border-color: $primary500;
    }

    &_true {
      background: $primary500;
      border-color: $primary500;

      &:hover {
        background: $primary600;
        border-color: $primary600;
      }
    }

    &_disabled {
      pointer-events: none;
      background-color: $grey50;
    }

    svg {
      width: 18px;
      height: 18px;
    }
  }
</style>
